
document.addEventListener("DOMContentLoaded", function() {
  let elem = document.querySelector('#product-grid');
  let infScroll = new InfiniteScroll( elem, {
    // options
    path: '.pagination__item--prev',
    history: false,
    append: '#product-grid .grid__item',
    button: '.view-more-button',
    scrollThreshold: false,
  });

  infScroll.on( 'append', function( body, path, items, response ) {
    if ( window.innerWidth > 990) {
      console.log('appended')
      gridImage();
    }
  });

  function wrapElement(elmts, nextElement, dir) {
    const wrapper = document.createElement('li');
    if ( dir === 'prev' ) {
      wrapper.classList.add('grid__item', 'grid__item-image-1-container');
    } else {
      wrapper.classList.add('grid__item', 'grid__item-image-2-container');
    }
    
    elmts.forEach(function(el) {
      wrapper.appendChild(el);
    });
    if (dir === 'prev') {
      nextElement.insertAdjacentElement('beforebegin', wrapper);
    } else {
      nextElement.insertAdjacentElement('afterend', wrapper);
    }
  }

  function theFourElements(currentElement, dir) {
    const nextElements = [];
    for (let i = 0; i < 4; i++) {
      if (dir === 'prev') {
        currentElement = currentElement.previousElementSibling;
        if (currentElement) {
          nextElements.push(currentElement);
        } else {
          break;
        }
      } else {
        currentElement = currentElement.nextElementSibling;
        if (currentElement) {
          nextElements.push(currentElement);
        } else {
          break;
        }
      }
    }
    return nextElements;
  }

  window.gridImage = function() {
    const gridImage1 = document.querySelector('.grid__item-image-1');
    const gridImage2 = document.querySelector('.grid__item-image-2');

    if ( gridImage1 && !document.querySelector('.grid__item-image-1-container') ) {
      const fourElements = theFourElements(gridImage1, 'prev');
      wrapElement(fourElements, gridImage1, 'prev');
    }
    
    if ( gridImage2 && !document.querySelector('.grid__item-image-2-container') ) {
      const fourElements = theFourElements(gridImage2);
      wrapElement(fourElements, gridImage2);
      console.log(fourElements, gridImage2)
    }
  }


  if ( window.innerWidth < 990 ) {
    // mobile view
    document.addEventListener('click', function(e) {
      const viewButton = e.target.closest('.facet-views__mobile .facet-views__one');
      if (viewButton) {
        e.preventDefault();
        const viewNum = viewButton.querySelector('span:last-child');
        const current = viewButton.dataset.toggleView;
        const elemGrid = document.querySelector('#product-grid');
        if (current === '1') {
          viewNum.textContent = '[2]';
          viewButton.dataset.toggleView = '2';
          if (elemGrid) {
            elemGrid.classList.add('show-2-grid');
            elemGrid.classList.remove('show-1-grid');
          }
        } else {
          viewNum.textContent = '[1]';
          viewButton.dataset.toggleView = '1';
          if (elemGrid) {
            elemGrid.classList.add('show-1-grid');
            elemGrid.classList.remove('show-2-grid');
          }
        }
      }
    });

    document.addEventListener('click', function(e) {
      const acc = e.target.closest(".sort-select-header, .facet-filter-container .facet-header");
      if (acc) {
        e.preventDefault();
        acc.classList.toggle("active");
        const panel = acc.nextElementSibling;
        if (acc.classList.contains('active')) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = '0';
        }
      }
    });
  } else {
    // grid image
    gridImage();
    
    const viewProductBtn = document.querySelector('.facet-views__desktop .facet-views__product');
    const viewModelBtn = document.querySelector('.facet-views__desktop .facet-views__model');
    
    document.addEventListener('click', function(e) {
      if (e.target === viewModelBtn) {
        e.preventDefault();
        viewModelBtn.classList.add('view-active');
        viewProductBtn.classList.remove('view-active');
        document.querySelector('#product-grid').classList.add('show-model');
      } else if (e.target === viewProductBtn) {
        e.preventDefault();
        viewProductBtn.classList.add('view-active');
        viewModelBtn.classList.remove('view-active');
        document.querySelector('#product-grid').classList.remove('show-model');
      }
    });

    viewModelBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add('view-active');
      viewProductBtn.classList.remove('view-active');
      elem.classList.add('show-model');
    });

    viewProductBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.target.classList.add('view-active');
      viewModelBtn.classList.remove('view-active');
      elem.classList.remove('show-model');
    });

    function initTagFilters() {
      const select = document.querySelector('#FilterTags');
      const tags = document.querySelectorAll('.filter-group .tag-item');

      tags.forEach(tag => {
        tag.addEventListener('click', function() {
          let value = this.getAttribute('data-tag-value');
          if (this.classList.contains('active')) {
            value = this.closest('.collection-tag-filter').getAttribute('data-tag-default');
          }
          let search = document.location.search.replace(/\?(page=\w+)?&?/, '');

          // only add the search parameters to the url if they exist
          search = search !== '' ? '?' + search : '';

          // document.location.href = filter + search + selectors.mainContent;
          document.location.href = value + search;
        });
      });
    }

    initTagFilters();
  }

  document.querySelector('.mobile-facets__close').addEventListener('click', function() {
    document.querySelector('.mobile-facets__open-wrapper').click();
  });

});
